import { render, staticRenderFns } from "./Locale.vue?vue&type=template&id=49e0aaab"
import script from "./Locale.vue?vue&type=script&lang=js"
export * from "./Locale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports